import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Lottie from './index';

export default class LottieAutoPlay extends Component {
  componentDidMount() {
    this.animation.play(undefined, undefined, this.props.onEnd);
  }

  render() {
    const { onEnd, ...lottieProps } = this.props;
    return (
      <Lottie
        {...lottieProps}
        ref={(animation) => {
          if (animation) {
            this.animation = animation;
          }
        }}
      />
    );
  }
}

LottieAutoPlay.propTypes = {
  onEnd: PropTypes.func,
};

LottieAutoPlay.defaultProps = {
  onEnd: () => {},
};
